import {makeStyles} from '@material-ui/core/styles'
import {Box, IconButton} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import {useState} from 'react'
import firstStepsApi from '../utils/firstStepsApi'
import RenderTemplate from './RenderTemplate'

const LEGAL_BANNER_STATE_SESSION_KEY = 'legal_banner_state' // 'enabled' | 'disabled'
const LEGAL_BANNER_STATE_DISABLED = 'disabled'

const useStyles = makeStyles((theme) => ({
    legal: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: theme.spacing(1, 2),
        backgroundColor: '#704DA0BB',
        color: '#ffffff',
        boxSizing: 'border-box',
        zIndex: theme.zIndex.appBar + 1,
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: '#fff',
    },
}))

const LegalBanner = () => {
    const classes = useStyles()

    const [showBanner, setShowBanner] = useState(() => {
        try {
            return sessionStorage.getItem(LEGAL_BANNER_STATE_SESSION_KEY) !== LEGAL_BANNER_STATE_DISABLED
        }
        catch {
            return true
        }
    })

    if (!showBanner) {
        return null
    }

    const handleClose = () => {
        try {
            sessionStorage.setItem(LEGAL_BANNER_STATE_SESSION_KEY, 'disabled')
        }
        catch (error) {
            console.error('error setting legal banner state', error)
        }
        setShowBanner(false)
    }

    return (
        <Box className={classes.legal}>
            <IconButton
                aria-label="Close legal banner"
                className={classes.closeButton}
                onClick={handleClose}
                size="small"
            >
                <CloseIcon fontSize="small" />
            </IconButton>

            <RenderTemplate
                fetchFn={firstStepsApi.getLegalBannerText}
                display="block"
                variant="body1"
                color="inherit"
            />
        </Box>
    )
}

export default LegalBanner
